import Reporting from './Reporting.vue';

export const reportingRoutes = [
  {
    path: 'reporting',
    name: 'reporting',
    component: Reporting,
  }];
